import "core-js/modules/es.number.constructor.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "detial-info"
};
var _hoisted_2 = {
  class: "info-label"
};
var _hoisted_3 = {
  class: "info-value"
};
var _hoisted_4 = {
  class: "coupon-reward"
};
var _hoisted_5 = {
  class: "point-worth-info"
};
var _hoisted_6 = {
  class: "rule-item"
};
var _hoisted_7 = {
  class: "rule-item-left"
};
var _hoisted_8 = {
  class: "rule-item"
};
var _hoisted_9 = {
  class: "rule-item-left"
};
var _hoisted_10 = {
  class: "rule-item"
};
var _hoisted_11 = {
  class: "rule-item-left"
};
import CommonCenter from "@/components/dialog/src/CommonCenter.vue";
import { useCartStore } from "@/store/cartStore";
import { useSupplierStore } from "@/store/supplierStore";
import { useUserStore } from "@/store/userStore";
import { Notify } from "@/utils/notifyUtil";
import { convertPoint2Price } from "@/utils/tools";
import { priceUtil } from "@op/shared";
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
export default {
  __name: 'PayWithPoints',
  props: {
    reduceAmount: {
      type: Number,
      default: 0
    },
    isNotNeed: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var cartStore = useCartStore();
    var userStore = useUserStore();
    var props = __props;
    var pointsPaymentRule = computed(function () {
      return supplierStore.getPointsPaymentRule;
    });
    var currency = computed(function () {
      return cartStore.getCartItemCurrency;
    });
    var points = computed(function () {
      return userStore.getPoints;
    });
    function handleCheck() {
      if (props.isNotNeed) {
        Notify.warn(t("pointsAndVoucherCodeCannotUseTogether"));
        return;
      }
      cartStore.setPoints(pointsPaymentRule.value);
    }
    function handleUncheck() {
      cartStore.setPoints(null);
    }
    var isRedeemRuleDialogVisible = ref(false);
    function handleConfirmDialog() {
      isRedeemRuleDialogVisible.value = false;
    }
    return function (_ctx, _cache) {
      var _component_SvgIcon = _resolveComponent("SvgIcon");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_SvgIcon, {
        name: "point",
        size: 20,
        class: "info-label-img"
      }), _createElementVNode("span", null, _toDisplayString(_ctx.$t("payWithPoints")), 1), _createVNode(_component_SvgIcon, {
        name: "question",
        size: 16,
        class: "info-label-icon",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return isRedeemRuleDialogVisible.value = true;
        })
      })]), _createElementVNode("div", _hoisted_3, [_unref(cartStore).getPoints ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "select-point-checked",
        onClick: handleUncheck
      }, [_createElementVNode("div", _hoisted_4, " -" + _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice(__props.reduceAmount, currency.value)), 1), _createVNode(_component_SvgIcon, {
        class: "point-checkbox--checked",
        name: "checkbox_round_checked",
        size: "16"
      })])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "select-point",
        onClick: handleCheck
      }, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("nPtsWorthM", [points.value, _unref(priceUtil).formatToShowPrice(_unref(convertPoint2Price)(points.value, pointsPaymentRule.value))])) + "​ ", 1), _createVNode(_component_SvgIcon, {
        class: "point-checkbox",
        name: "checkbox_round",
        size: "16"
      })]))])]), _createVNode(CommonCenter, {
        visible: isRedeemRuleDialogVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return isRedeemRuleDialogVisible.value = $event;
        }),
        title: _ctx.$t('redeemRule'),
        "on-ok": handleConfirmDialog,
        "ok-text": _ctx.$t('gotIt'),
        "without-cancel": true
      }, {
        content: _withCtx(function () {
          return [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("points2CashRate")), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t("nPts", [pointsPaymentRule.value.conversion_rate])) + " = " + _toDisplayString(_unref(priceUtil).formatToShowPrice(1, currency.value)), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("miniRedemptionUnit")), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t("nPts", [pointsPaymentRule.value.min_redemption_inc])), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("redeemStartsFrom")), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t("nPts", [pointsPaymentRule.value.redeem_starts_from])), 1)])])];
        }),
        _: 1
      }, 8, ["visible", "title", "ok-text"])]);
    };
  }
};